export const styles = () => ({
  iconButton: {
    padding: 4
  }
})



// WEBPACK FOOTER //
// ./src/components/Sources/components/SourceOption/styles.js